import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import RestService from '../rest.service';
import CacheService from '@components/collection/components/globals/backend-services/cache.service';
var BANNER_URL = 'api/v1/customerfacing/cms/banners/search?';
var CMS_PAGE_URL = 'api/v1/customerfacing/cms/pages/searchBySlug?';
var CMS_PAGES_URL = 'api/v2/customerfacing/cms/pages/search';

var CmsService = /*#__PURE__*/function () {
  function CmsService() {
    _classCallCheck(this, CmsService);
  }

  _createClass(CmsService, [{
    key: "getAll",
    value: function getAll() {
      return new Promise(function (resolve, reject) {
        CacheService.cacheRequest(CMS_PAGES_URL, function () {
          return RestService.request(CMS_PAGES_URL, {
            method: "GET"
          }, true);
        }).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "getBanner",
    value: function getBanner(location, locale, deviceType) {
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'BANNER';

      if (contentType === 'INLINE_CONTENT') {
        deviceType = 'DESKTOP';
      }

      return new Promise(function (resolve, reject) {
        CacheService.cacheRequest("".concat(BANNER_URL, "location=").concat(location, "&locale=").concat(locale, "&deviceType=").concat(deviceType, "&contentType=").concat(contentType), function () {
          return RestService.request("".concat(BANNER_URL, "location=").concat(location, "&locale=").concat(locale, "&deviceType=").concat(deviceType, "&contentType=").concat(contentType), {
            method: "POST"
          }, true);
        }).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "getPage",
    value: function getPage(slug, locale, deviceType) {
      return new Promise(function (resolve, reject) {
        CacheService.cacheRequest("".concat(CMS_PAGE_URL, "pageSlug=").concat(slug, "&locale=").concat(locale, "&deviceType=").concat(deviceType), function () {
          return RestService.request("".concat(CMS_PAGE_URL, "pageSlug=").concat(slug, "&locale=").concat(locale, "&deviceType=").concat(deviceType), {
            method: "POST"
          }, true);
        }).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }]);

  return CmsService;
}();

export default new CmsService();